import Plyr from 'plyr/dist/plyr.polyfilled.js';

import '../../sass/blocks/video.scss';

(() => {
    const $videos = document.querySelectorAll('.video');

    if (!$videos) return;

    $videos.forEach($video => {
        const $videoPlayer = $video.querySelector('.video__player');
        const $playBtn = $video.querySelector('.video__play-btn');

        const initVideo = () => {
            const {poster} = $videoPlayer.dataset;

            const player = new Plyr($videoPlayer, {
                controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
            });

            if ($playBtn) {
                $playBtn.addEventListener('click', () => {
                    player.play();
                });
            }

            if (poster) {
                player.on('ready', () => {
                    player.poster = poster;
                });
            }
        };

        initVideo();
    });
})();
